import axiosInstance from "../config/axiosIntance";
import { BFF_BASE_URL } from "../config/constants";
import { TemplatesHistoryResponse } from "../types";

type TemplateHistoryParams = {
  purposeName?: string;
  country?: string;
  business?: string;
  page?: number;
  limit?: number;
  token: string;
};

export const getTemplatesHistoryService = async ({
  purposeName,
  country,
  business,
  page,
  limit,
  token
}: TemplateHistoryParams): Promise<TemplatesHistoryResponse> => {
  const params: Record<string, string | number> = {
    ...(purposeName && { purposeName }),
    ...(country && { country }),
    ...(business && { business }),
    ...(page && { page }),
    ...(limit && { limit })
  };

  const dataFetched = await axiosInstance.get<TemplatesHistoryResponse>(
    `${BFF_BASE_URL}/ciam-tools-bff/consent-config/draft/purposes/draftsTemplates`,
    {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return dataFetched.data;
};
